import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "FooterLazy" */ './YodaFooter'), {
    fallback: null,
});
